import { render, staticRenderFns } from "./printTable.vue?vue&type=template&id=89a641e2&scoped=true&"
import script from "./printTable.vue?vue&type=script&lang=js&"
export * from "./printTable.vue?vue&type=script&lang=js&"
import style0 from "./printTable.vue?vue&type=style&index=0&id=89a641e2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89a641e2",
  null
  
)

export default component.exports